import React from 'react';
import PropTypes from 'prop-types';
import {
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import StatusBadge from './StatusBadge';

const LearningRunsTable = ({ items, onSelectRun, loading = false }) => {
  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Created</TableCell>
            <TableCell>Sample</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Reason</TableCell>
            <TableCell>Duration</TableCell>
            <TableCell>Proposal Confidence</TableCell>
            <TableCell>Changed Fields</TableCell>
            <TableCell>Validation</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {loading ? Array.from({ length: 4 }).map((_, index) => (
            <TableRow key={`skeleton-${index}`}>
              {Array.from({ length: 8 }).map((__, cellIndex) => (
                <TableCell key={cellIndex}><Skeleton variant="text" /></TableCell>
              ))}
            </TableRow>
          )) : items.length ? items.map((item) => (
            <TableRow
              key={item.id}
              hover
              sx={{ cursor: 'pointer' }}
              onClick={() => onSelectRun(item.id)}
            >
              <TableCell>{new Date(item.created_at).toLocaleString()}</TableCell>
              <TableCell>
                <Typography variant="body2">{item.sample_size}</Typography>
                <Typography variant="caption" color="text.secondary">
                  {item.ready_to_learn ? 'Ready' : 'Collecting'}
                </Typography>
              </TableCell>
              <TableCell><StatusBadge value={item.status} /></TableCell>
              <TableCell>
                <Typography variant="body2">{item.reason_code || 'N/A'}</Typography>
                {Object.keys(item.reason_meta || {}).length ? (
                  <Typography variant="caption" color="text.secondary">{JSON.stringify(item.reason_meta)}</Typography>
                ) : null}
              </TableCell>
              <TableCell>{item.duration_ms ?? 'N/A'}</TableCell>
              <TableCell>{item.proposal_confidence ?? 'N/A'}</TableCell>
              <TableCell>{item.changed_fields_count}</TableCell>
              <TableCell><StatusBadge value={item.validation_state} /></TableCell>
            </TableRow>
          )) : (
            <TableRow>
              <TableCell colSpan={8}>
                <Typography variant="body2" color="text.secondary">Chưa có learning runs.</Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

LearningRunsTable.propTypes = {
  items: PropTypes.array.isRequired,
  onSelectRun: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

export default LearningRunsTable;
